import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AudioRecorder from "../../utilities/AudioRecorder";
import axios from "axios";

import Transcribe from "./Transcribe";
import Wizard from "../../utilities/Wizard";
import RichTextEditor from "../../utilities/RichTextEditor";

const EndPoint = process.env.REACT_APP_API_ENDPOINT;



const snippets = [
  {
    shortcut: "$exam",
    content: `General appearance:
Cardiovascular:
Respiratory:
Abdominal:
Extremities:\n`,
  },
  {
    shortcut: "$neuroxm",
    content: `Mental state:
Cranial nerves II–XII:
Motor:
Sensory:
Reflexes:
Gait:\n`,
  },
  {
    shortcut: "$mhxm",
    content: `Appearance:
Behaviour:
Speech:
Mood:
Affect:
Thought form:
Thought content:
Insight:\n`,
  },
];



class Consultation extends React.Component {
  state = {
    selectedIndex: -1,
    rawText: "",
    text: "",
   
    // tabs
    tabs: [
      { id: "note", title: "Consultation Note" },
    ],
    activeTab: "note",

    // templates (dummy)
    templates:[],

    // add-tab modal
    showAddTabModal: false,
    newTabTitle: "",


    // right panel mode
    isEditing: false,
    editOriginalText: "",

    switches: {
      GPCCMP: false,
      MHCP: false,
      HA: false,
    }, 
  };

  richTextRef = React.createRef();
  customQuillRefs = {}; 
    htmlToText = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return (div.textContent || div.innerText || "").trim();
  };

getTemplates = async () => {
  try {
    const token = this.props.token || localStorage.getItem("token") || "";

    const res = await axios.get(`${EndPoint}/promptUser/list`, {
      withCredentials: true,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    const data = res.data || {};
    const list = data.prompts || data.items || data.collection || [];

    return list.map((p) => ({
      id: String(p._id),
      title: p.title || "Untitled",
      prompt: p.promptText || "",
      description: p.description || "",
      category: p.category || "",
      tags: Array.isArray(p.tags) ? p.tags : [],
    }));
  } catch (e) {
    console.error("Failed to load templates:", e?.message || e);
    return [];
  }
};


  setSuggestedWorkspaceTitle = (title) => {
    this.setState({ newTabTitle: title });
  };

getTemplateForWorkspaceTitle = (title = "") => {
  const t = (title || "").toLowerCase();
  const templates = this.state.templates || [];

  const findByTitle = (needle) =>
    templates.find((x) => (x.title || "").toLowerCase().includes(needle));

  if (t.includes("referral")) return findByTitle("referral");
  if (t.includes("patient summary")) return findByTitle("patient summary");
  if (t.includes("instruction")) return findByTitle("instruction");

  return templates[0];
};



  isProbablyHtml = (s = "") => /<\/?[a-z][\s\S]*>/i.test(String(s));

  ensureQuillHtml = (s = "") => {
    if (!s) return "";
    return this.isProbablyHtml(s)
      ? String(s)
      : this.formatNoteToHtml(String(s));
  };

  
  async componentDidMount() {
    this.syncFromProps(this.props);

    const templates = await this.getTemplates();
    this.setState({ templates });
}


  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.syncFromProps(this.props);
    }
  }

  
escapeHtml = (s = "") =>
  String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

// Convert rawResponse (plain text) to Quill-friendly HTML,
// bolding section headings when they appear at the start of a line.
formatNoteToHtml = (raw = "") => {
  const safe = this.escapeHtml(raw);

  const lines = safe.split(/\r?\n/);

  const headingRegex = /^(Subjective|Objective|Assessment|Plan|Planning)\s*:?(\s*)(.*)$/i;

  const htmlLines = lines.map((line) => {
    const trimmed = line.trim();

    // blank line -> spacing
    if (!trimmed) return "<p><br/></p>";

    const m = trimmed.match(headingRegex);
    if (m) {
      const heading = m[1];       // matched word
      const rest = m[3] || "";    // rest of the line after heading
      // Keep original heading casing (you can force Title Case if you want)
      return rest
        ? `<p><strong>${heading}</strong>: ${rest}</p>`
        : `<p><strong>${heading}</strong>:</p>`;
    }

    return `<p>${trimmed}</p>`;
  });

  return htmlLines.join("");
};

htmlToText = (html = "") => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return (div.textContent || div.innerText || "").trim();
};

  syncFromProps = (props) => {
    const list = Array.isArray(props.value) ? props.value : [];
    if (this.state.selectedIndex === -1 && list.length > 0) {
      this.selectIndex(0, list);
    }
  };

  // ✅ click left card -> view mode (readonly)
  selectIndex = (index, listOverride) => {
    const list =
      listOverride || (Array.isArray(this.props.value) ? this.props.value : []);
    const item = list[index];
    if (!item) return;

    this.setState({
      selectedIndex: index,
      text: item.note || "",
      isEditing: false,
      editOriginalText: item.note || "",
    });
  };

  updateList = (next) => {
    console.log(next)
    if (typeof this.props.onChange === "function") this.props.onChange(next);
  };

  deleteItem = (index) => {
    const list = Array.isArray(this.props.value) ? this.props.value : [];
    const item = list[index];
    if (!item) return;

    const next = list.filter((_, i) => i !== index);
    this.updateList(next);

    if (typeof this.props.onDelete === "function") this.props.onDelete(item, index);

    // reset selection safely
    let selectedIndex = this.state.selectedIndex;
    if (selectedIndex === index) selectedIndex = -1;
    if (selectedIndex > index) selectedIndex = selectedIndex - 1;

    this.setState(
      {
        selectedIndex,
        isEditing: false,
        editOriginalText: "",
        text:
          selectedIndex >= 0 && next[selectedIndex] ? next[selectedIndex].note || "" : "",
      },
      () => {
        if (selectedIndex === -1 && next.length > 0) this.selectIndex(0, next);
      }
    );
  };

  handleTextareaChange = (e) => {
    // ✅ only allow typing when editing
    if (!this.state.isEditing) return;
    this.setState({ text: e.target.value });
  };

  // ✅ right-side Edit button
  beginEdit = () => {
    const { selectedIndex } = this.state;
    const list = Array.isArray(this.props.value) ? this.props.value : [];
    if (selectedIndex < 0 || !list[selectedIndex]) {
      toast.warn("Select a note first.");
      return;
    }

    this.setState(
      {
        isEditing: true,
        editOriginalText: this.state.text,
      },
      () => {
        this._boundQuillShortcuts = false;
        this.bindQuillShortcuts();
      }
    );
  };


  // ✅ right-side Cancel
  cancelEdit = () => {
    this.setState((prev) => ({
      isEditing: false,
      text: prev.editOriginalText || prev.text,
    }));
  };

  // ✅ right-side Update
  updateExistingNote = () => {
    const { selectedIndex, text } = this.state;
    const list = Array.isArray(this.props.value) ? this.props.value : [];
    if (selectedIndex < 0 || !list[selectedIndex]) return;

    const note = (text || "").trim();
    if (!note) {
      toast.warn("Note cannot be empty.");
      return;
    }

    const next = list.map((x, i) => (i === selectedIndex ? { ...x, note } : x));
    this.updateList(next);

    this.setState({
      isEditing: false,
      editOriginalText: note,
      text: note,
    });

    toast.success("Updated.", { autoClose: 1200 });
  };

  processNote = async () => {
    
    const { text, switches } = this.state;
    const textPlain = this.htmlToText(text);

    if (switches.GPCCMP) {
        if (typeof this.props.onChangeGPCCMP === "function") {
            this.props.onChangeGPCCMP(textPlain);
        }
    }

    if (switches.HA) {
      var toastHA = toast.loading("Processing notes for Health Assessment...");

      try {
      
      const current = this.props.valueHA || {};
      const res = await axios.post(
        `${EndPoint}/careplan/healthassessment`,
        {
          transcription: textPlain,
          initData: current,
        },
        { withCredentials: true }
      );

        const payload = res?.data || {};
            const ai = JSON.parse(payload?.respond || "{}");

            const prevHealth = current.health || {};
       
            const updatedHealth = {
              ...prevHealth,
              // Core HA fields from AI
              substance: ai.substance,
              medicationArrangement: ai.medicationArrangement,
              vision: ai.vision,
              hearing: ai.hearing,
              fallAndHomeSafety: ai.fallAndHomeSafety,
              skin: ai.skin,
              feet: ai.feet,
              nutrition: ai.nutrition,
              oralHealth: ai.oralHealth,
              cognition: ai.cognition,
              mentalHealth: ai.mentalHealth,
              urineContinence: ai.urineContinence,
              faecalContinence: ai.faecalContinence,
              mobility: ai.mobility,
              activity: ai.activity,
              social: ai.social,
              housing: ai.housing,
              legal: ai.legal,
              finance: ai.finance,
              driving: ai.driving,
              advancedCareDirective: ai.advancedCareDirective,
              services: ai.services,
              examination: ai.examination,
              surveillance: ai.surveillance,
              // keep date exactly what user already has
              date: prevHealth.date || "",
            };
      
            const nextValue = {
              ...current,
              health: updatedHealth,
            };
      
            if (typeof this.props.onChangeHA === "function") {
              this.props.onChangeHA(nextValue);
            }
     
            // credits 
            if (payload?.output) {
              const creditUsed = payload.output.amount;
              const newBalance = payload.output.newBalance;
              const reason = payload.output.reason;
              toast.info(`${creditUsed} credits was used to ${reason}`, {
                autoClose: 1500,
              });
              this.props.onCredits(newBalance);
            }
      
            toast.update(toastHA, {
              render: "Health assessment updated",
              type: "success",
              isLoading: false,
              autoClose: 1100,
            });

        } catch (err) {
          console.error(err);
          toast.update(toastHA, {
            render: "Error updating health assessment",
            type: "error",
            isLoading: false,
            autoClose: 2000,
          });
        }
    }

    if (switches.MHCP) {

      const current = this.props.valueMHCP;


      var toastMHCP = toast.loading("Processing notes for Mental Health Care Plan...");
      try {
        const res = await axios.post(
          `${EndPoint}/careplan/mhcp`,
          {
            transcription: textPlain,
            initData: current
          },
          { withCredentials: true }
        );

        const payload = res?.data;
        const ai = JSON.parse(payload?.respond);
  

        //mental state exam
        const mse =
          ai && typeof ai.mentalStateExamination === "object"
          ? Object.entries(ai.mentalStateExamination)
              .map(([k, v]) => `${k}: ${v}`)
              .join("\n ")
          : ai?.mentalStateExamination || "";

        if (ai) {
          const nextValue = {
            ...current,
            mhcp: {
              ...(current.mhcp || {}),
              presentingIssue: ai.presentingIssue,
              history: ai.history,
              pastHistory: ai.pastHistory,
              childhoodHistory: ai.childhoodHistory,
              familyHistory: ai.familyHistory,
              parentChildNeed: ai.parentChildNeed,
              occupation: ai.occupation,
              social: ai.social,
              substance: ai.substance,
              currentMedication: ai.currentMedication,
              allergies: ai.allergies,
              treatmentHistory: ai.treatmentHistory,
              medicationHistory: ai.medicationHistory,
              relevantExamination: ai.relevantExamination,
              relevantInvestigation: ai.relevantInvestigation,
              devTesting: ai.devTesting,
              mentalStateExamination: mse,
              risk: ai.risk,
              tools: ai.tools,
              diagnosis: ai.diagnosis,
            },

            mhformulation: {
              ...(current.mhformulation || {}),
              predisposing: ai.predisposing,
              precipitating: ai.precipitating,
              perpetuating: ai.perpetuating,
              protective: ai.protective,
            },

            mhsafety: {
              ...(current.mhsafety || {}),
              reason: ai.reason,
              cando: ai.cando,
              help: ai.help,
              call: ai.call,
              talk: ai.talk,
              professional: ai.professional,
            },

            relapsePrevention: {
              ...(current.relapsePrevention || {}),
              triggers: ai.triggers,
              warningSigns: ai.warningSigns,
              copingStrategy: ai.copingStrategy,
              support: ai.support,
              emergency: ai.emergency,
            },
          };

          if (this.props.onChangeMHCP) {
            this.props.onChangeMHCP(nextValue);
          }

          
          toast.update(toastMHCP, {
            render: "Finish updating Mental Health Care Plan",
            type: "success",
            isLoading: false,
            autoClose: 1100,
          });
        }

        // credits part unchanged
        if (payload?.output) {
          const creditUsed = payload.output.amount;
          const newBalance = payload.output.newBalance;
          const reason = payload.output.reason;
          toast.info(`${creditUsed} credits was used to ${reason}`, { autoClose: 1500 });
          this.props.onCredits(newBalance);
        }
    
      } catch (err) {
        console.error(err);
      }
    }

  };

  handleTranscription = (data = {}) => {
    const transcription = data?.transcription || "";
    if (!transcription) {
      toast.warn("No transcription returned.");
      return;
    }

    this.setState({ rawText: transcription }, () => {
      this.toastId = toast.loading("Writing note..");
      this.handleTextProcessing(this.toastId, transcription);
    });
  };

  // Audio creates text in the right textarea, but keep it readonly until user clicks Edit
  handleTextProcessing = async (toastId, transcriptionArg) => {
    const transcription = transcriptionArg ?? this.state.rawText ?? "";
    if (!transcription) {
      toast.update(toastId, {
        render: "No transcription to process.",
        type: "warning",
        isLoading: false,
        autoClose: 1500,
      });
      return;
    }

    try {
      const res = await axios.post(
        `${EndPoint}/careplan/consultation`,
        { transcription },
        { withCredentials: true }
      );

      const rawResponse = res?.data?.success || "";

      // deduct credits
      if (res?.data?.output) {
        const { amount, newBalance, reason } = res.data.output;
        toast.info(`${amount} credits was used to ${reason}`, { autoClose: 1500 });
        if (typeof this.props.onCredits === "function") {
          this.props.onCredits(newBalance);
        }
      }

      if (!rawResponse) {
        toast.update(toastId, {
          render: "No note returned from AI.",
          type: "warning",
          isLoading: false,
          autoClose: 1500,
        });
        return;
      }

      toast.update(toastId, {
        render: "Consultation note created successfully",
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });

      // ✅ ADD TO DATA IMMEDIATELY
      const htmlResponse = this.formatNoteToHtml(rawResponse);
      const currentList = Array.isArray(this.props.value) ? this.props.value : [];

      const newItem = {
        date: new Date().toLocaleDateString("en-AU", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }),
        note: htmlResponse,        // HTML
        rawText: transcription,   // 👈 ADD THIS
        AIprocess: [],            
      };

      const nextList = [newItem, ...currentList];

      if (typeof this.props.onChange === "function") {
        this.props.onChange(nextList);
      }

      // ✅ select the newly created note, keep readonly


      this.setState({
        selectedIndex: 0,
        text: htmlResponse,          // now HTML
        isEditing: false,
        editOriginalText: htmlResponse,
      });

      return rawResponse;
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Request failed";

      toast.update(toastId, {
        render: msg,
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
  };

  // copyNoteToClipboard = async () => {
  //   const text = this.state.text || "";
  //   if (!text.trim()) {
  //     toast.warn("Nothing to copy.");
  //     return;
  //   }

  //   try {
  //     if (navigator.clipboard && window.isSecureContext) {
  //       await navigator.clipboard.writeText(text);
  //     } else {
  //       // fallback for older browsers / non-HTTPS
  //       const ta = document.createElement("textarea");
  //       ta.value = text;
  //       ta.style.position = "fixed";
  //       ta.style.left = "-9999px";
  //       document.body.appendChild(ta);
  //       ta.focus();
  //       ta.select();
  //       document.execCommand("copy");
  //       document.body.removeChild(ta);
  //     }

  //     toast.success("Copied to clipboard.", { autoClose: 1200 });
  //   } catch {
  //     toast.error("Failed to copy.");
  //   }
  // };

  copyNoteToClipboard = async () => {
  const html = this.state.text || "";          // Quill HTML
  if (!html.trim()) {
    toast.warn("Nothing to copy.");
    return;
  }

  const plain = this.htmlToText(html);         // fallback text

  try {
    // Modern browsers (Chrome, Edge, Safari 16+)
    if (navigator.clipboard && window.ClipboardItem) {
      const item = new ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" }),
        "text/plain": new Blob([plain], { type: "text/plain" }),
      });

      await navigator.clipboard.write([item]);
    } else {
      // Fallback for older browsers
      const temp = document.createElement("div");
      temp.innerHTML = html;
      temp.style.position = "fixed";
      temp.style.left = "-9999px";
      document.body.appendChild(temp);

      const range = document.createRange();
      range.selectNodeContents(temp);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      document.execCommand("copy");
      document.body.removeChild(temp);
    }

    toast.success("Note copied", { autoClose: 1200 });
  } catch (err) {
    console.error(err);
    toast.error("Failed to copy.");
  }
};


  // Toggle Processing note
  toggleSwitch = (key) => {
    this.setState((prev) => ({
      switches: { ...prev.switches, [key]: !prev.switches[key] },
    }));
  };

  renderToggle = (label, field) => {
    const on = !!this.state.switches[field];
    return (
      <button
        type="button"
        onClick={() => this.toggleSwitch(field)}
        className="flex items-center gap-3 select-none"
      >
        <span
          className={[
            "relative inline-flex h-6 w-11 items-center rounded-full transition",
            on ? "bg-sky-700" : "bg-gray-300",
          ].join(" ")}
        >
          <span
            className={[
              "inline-block h-5 w-5 transform rounded-full bg-white transition",
              on ? "translate-x-5" : "translate-x-1",
            ].join(" ")}
          />
        </span>
        <span className="text-sm">{label}</span>
      </button>
    );
  };

  openAddTabModal = () => {
    this.setState({ showAddTabModal: true, newTabTitle: "" });
  };

  closeAddTabModal = () => {
    this.setState({ showAddTabModal: false, newTabTitle: "" });
  };

  handleNewTabTitleChange = (e) => {
    this.setState({ newTabTitle: e.target.value });
  };

 addNewTab = () => {
    const title = (this.state.newTabTitle || "").trim();
    if (!title) {
      toast.warn("Tab title cannot be empty.");
      return;
    }

    const id = `tab-${Date.now()}`;

    const matchedTemplate = this.getTemplateForWorkspaceTitle(title);

    this.setState((prev) => ({
      tabs: [
        ...prev.tabs,
        {
          id,
          title,
          type: "custom",

          // ✅ auto-match select box + prompt
          selectedTemplateId: matchedTemplate?.id || (prev.templates?.[0]?.id || ""),
          promptText: matchedTemplate?.prompt || (prev.templates?.[0]?.prompt || ""),

          outputText: "",
          isEditingOutput: false,
          outputOriginalText: "",
        },
      ],
      activeTab: id,
      showAddTabModal: false,
      newTabTitle: "",
    }));
  };


  getActiveTabObj = () => {
    return this.state.tabs.find((t) => t.id === this.state.activeTab);
  };

  updateTab = (tabId, patch, cb) => {
    this.setState(
      (prev) => ({
        tabs: prev.tabs.map((t) => (t.id === tabId ? { ...t, ...patch } : t)),
      }),
      cb
    );
  };


  handleTemplateChange = (tabId, templateId) => {
    const template = (this.state.templates || []).find((t) => t.id === templateId);

    this.updateTab(tabId, {
      selectedTemplateId: templateId,
      promptText: template?.prompt || "",
    });
  };

  handleInputTextChange = (tabId, e) => {
    this.updateTab(tabId, { inputText: e.target.value });
  };

  handlePromptTextChange = (tabId, e) => {
    // if you want prompt editable
    this.updateTab(tabId, { promptText: e.target.value });
  };

  beginEditTabOutput = (tabId) => {
    const tab = this.state.tabs.find((t) => t.id === tabId);
    if (!tab) return;

    this.updateTab(
      tabId,
      {
        isEditingOutput: true,
        outputOriginalText: tab.outputText || "",
      },
      () => {
        // ✅ force re-bind for this editor
        this._quillBound = this._quillBound || {};
        this._quillBound[`${tabId}-output`] = false;

        // ✅ bind now that Quill is editable + mounted
        const outputRef = this.getCustomQuillRef(tabId, "output");
        this.bindQuillShortcutsForRef(`${tabId}-output`, outputRef);
      }
    );
  };


  cancelEditTabOutput = (tabId) => {
    const tab = this.state.tabs.find((t) => t.id === tabId);
    if (!tab) return;

    this.updateTab(tabId, {
      isEditingOutput: false,
      outputText: tab.outputOriginalText || tab.outputText || "",
    });
  };

  updateTabOutputText = (tabId, e) => {
    const tab = this.state.tabs.find((t) => t.id === tabId);
    if (!tab?.isEditingOutput) return;
    this.updateTab(tabId, { outputText: e.target.value });
  };

  copyTabOutput = async (tabId) => {
    const tab = this.state.tabs.find((t) => t.id === tabId);
    const html = tab?.outputText || "";
    if (!html.trim()) return toast.warn("Nothing to copy.");

    const plain = this.htmlToText(html);

    try {
      if (navigator.clipboard && window.ClipboardItem) {
        await navigator.clipboard.write([
          new ClipboardItem({
            "text/html": new Blob([html], { type: "text/html" }),
            "text/plain": new Blob([plain], { type: "text/plain" }),
          }),
        ]);
      } else {
        await navigator.clipboard.writeText(plain);
      }
      toast.success("Copied.", { autoClose: 1200 });
    } catch {
      toast.error("Failed to copy.");
    }
  };


  processCustomTab = async (tabId) => {
    const tab = this.state.tabs.find((t) => t.id === tabId);
    if (!tab) return;

    const prompt = (tab.promptText || "").trim();
    if (!prompt) {
      toast.warn("Prompt is empty.");
      return;
    }

    const toastId = toast.loading("Processing...");

    try {
      const res = await axios.post(
        `${EndPoint}/careplan/ai-processing`,
        {
          title: tab.title,
          prompt,
          consultationNote: this.state.rawText, // ✅ your raw transcription
        },
        { withCredentials: true }
      );

      /**
       * ✅ Adjust this based on your backend response.
       * Common shapes:
       * - res.data.result
       * - res.data.success
       * - res.data.respond (string)
       */
      const payload = res?.data || {};

      const result =
        payload.result ||
        payload.success ||
        payload.respond ||
        payload.text ||
        (typeof payload === "string" ? payload : JSON.stringify(payload, null, 2));

      const resultPlain =
        payload.result || payload.success || payload.respond || payload.text || "";

      const resultHtml = this.formatNoteToHtml(resultPlain); // ✅ preserves paragraphs

      this.updateTab(tabId, {
        outputText: resultHtml,
        isEditingOutput: false,
        outputOriginalText: resultHtml,
      });

      // 👇 Persist into consultation data
      this.addAIProcessToCurrentConsultation({
        title: tab.title,
        prompt,
        output: resultPlain,
      });

      // optional credits message if your backend returns output like your other endpoints
      if (payload?.output) {
        const creditUsed = payload.output.amount;
        const newBalance = payload.output.newBalance;
        const reason = payload.output.reason;
        toast.info(`${creditUsed} credits was used to ${reason}`, { autoClose: 1500 });
        if (typeof this.props.onCredits === "function") this.props.onCredits(newBalance);
      }

      toast.update(toastId, {
        render: "Done",
        type: "success",
        isLoading: false,
        autoClose: 1200,
      });
    } catch (err) {
      console.error(err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Request failed";

      toast.update(toastId, {
        render: msg,
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
  };

  addAIProcessToCurrentConsultation = ({ title, prompt, output }) => {
    const { selectedIndex } = this.state;
    const list = Array.isArray(this.props.value) ? this.props.value : [];

    if (selectedIndex < 0 || !list[selectedIndex]) return;

    const current = list[selectedIndex];

    const nextItem = {
      ...current,
      AIprocess: [
        ...(current.AIprocess || []),
        { title, prompt, output },
      ],
    };

    const nextList = list.map((item, idx) =>
      idx === selectedIndex ? nextItem : item
    );

    if (typeof this.props.onChange === "function") {
      this.props.onChange(nextList);
    }
  };

  findSnippet = (word = "") => {
    const w = (word || "").toLowerCase();
    return snippets.find((s) => (s.shortcut || "").toLowerCase() === w);
  };

  expandShortcutInTextarea = ({ e, value, setValue }) => {
    // triggers only on Space/Enter (feel free to add Tab too)
    if (e.key !== " " && e.key !== "Enter") return false;

    const textarea = e.target;
    const cursor = textarea.selectionStart;

    const before = value.slice(0, cursor);
    const after = value.slice(cursor);

    // last token before cursor
    const parts = before.split(/\s+/);
    const lastWord = parts[parts.length - 1];

    const match = this.findSnippet(lastWord);
    if (!match) return false;

    // replace lastWord with snippet content
    const newBefore = before.slice(0, before.length - lastWord.length) + match.content;
    const newValue = newBefore + after;

    setValue(newValue, () => {
      const newCursor = newBefore.length;
      textarea.selectionStart = textarea.selectionEnd = newCursor;
    });

    e.preventDefault();
    return true;
  };

  bindQuillShortcuts = () => {
    const editor = this.richTextRef?.current?.getEditor?.();
    if (!editor) return;

    if (this._boundQuillShortcuts) return;
    this._boundQuillShortcuts = true;

    const tryExpand = () => {
      const range = editor.getSelection();
      if (!range) return true;

      const lookback = 80;
      const start = Math.max(0, range.index - lookback);
      const chunk = editor.getText(start, range.index - start);

      const lastWord = (chunk.split(/\s+/).pop() || "").trim();
      const match = this.findSnippet(lastWord);
      if (!match) return true;

      editor.deleteText(range.index - lastWord.length, lastWord.length, "user");
      editor.insertText(range.index - lastWord.length, match.content, "user");

      const newPos = range.index - lastWord.length + match.content.length;
      editor.setSelection(newPos, 0, "user");

      return false;
    };

    editor.keyboard.addBinding({ key: 32 }, () => tryExpand()); // Space
    editor.keyboard.addBinding({ key: 13 }, () => tryExpand()); // Enter
  };

  getCustomQuillRef = (tabId, field) => {
    if (!this.customQuillRefs[tabId]) {
      this.customQuillRefs[tabId] = {
        prompt: React.createRef(),
        output: React.createRef(),
      };
    }
    return this.customQuillRefs[tabId][field];
  };

  bindQuillShortcutsForRef = (refKey, refObj) => {
    const editor = refObj?.current?.getEditor?.();
    if (!editor) return;

    // prevent double-binding per editor instance
    this._quillBound = this._quillBound || {};
    if (this._quillBound[refKey]) return;
    this._quillBound[refKey] = true;

    const tryExpand = () => {
      const range = editor.getSelection();
      if (!range) return true;

      const lookback = 80;
      const start = Math.max(0, range.index - lookback);
      const chunk = editor.getText(start, range.index - start);

      const lastWord = (chunk.split(/\s+/).pop() || "").trim();
      const match = this.findSnippet(lastWord);
      if (!match) return true;

      editor.deleteText(range.index - lastWord.length, lastWord.length, "user");
      editor.insertText(range.index - lastWord.length, match.content, "user");

      const newPos = range.index - lastWord.length + match.content.length;
      editor.setSelection(newPos, 0, "user");

      return false;
    };

    editor.keyboard.addBinding({ key: 32 }, () => tryExpand()); // Space
    editor.keyboard.addBinding({ key: 13 }, () => tryExpand()); // Enter
  };



  renderCustomTab = (tab) => {
    const templates = this.state.templates || [];
    const selectedId = tab.selectedTemplateId || "";

    return (
      <div className="space-y-3">
        {/* Dropdown */}

        <div className="text-sm font-semibold">{tab.title}</div>
        <select
          className="border border-slate-300 rounded-lg px-2 py-1 text-sm w-full"
          value={tab.selectedTemplateId || ""}
          onChange={(e) => this.handleTemplateChange(tab.id, e.target.value)}
        >
          {templates.map((t) => (
            <option key={t.id} value={t.id}>
              {t.title}
            </option>
          ))}
        </select>
      

        {/* Prompt textarea (5 rows) */}
        <div>
          <div className="text-xs text-gray-500 mb-1">Prompt</div>
          <textarea
            rows={5}
            className="w-full border border-slate-200 rounded-lg p-2 text-sm"
            value={tab.promptText || ""}
            onChange={(e) => this.handlePromptTextChange(tab.id, e)}
            onKeyDown={(e) =>
              this.expandShortcutInTextarea({
                e,
                value: tab.promptText || "",
                setValue: (v, cb) => this.updateTab(tab.id, { promptText: v }, cb),
              })
            }
            placeholder="Type $exam then space/Enter..."
          />

        </div>

        {/* Process button */}
        <button
          type="button"
          onClick={() => this.processCustomTab(tab.id)}
          className="w-full bg-sky-700 hover:bg-sky-800 text-white rounded-lg px-3 py-2 text-sm shadow"
        >
          Process
        </button>

        {/* Output textarea (40 rows) */}
        <div>
          <div className="text-xs text-gray-500 mb-1">Output</div>
           <RichTextEditor
              key={tab.isEditingOutput ? "editing" : "readonly"} 
              ref={this.getCustomQuillRef(tab.id, "output")}
               value={this.ensureQuillHtml(tab.outputText || "")} 
              onChange={(html) => {
                if (!tab.isEditingOutput) return;
                this.updateTab(tab.id, { outputText: html });
              }}
              readOnly={!tab.isEditingOutput}
              className={`quill ${tab.isEditingOutput ? "quill-editing" : "quill-readonly"}`}
            />

        </div>

        {/* Edit + Copy buttons */}
        {!tab.isEditingOutput ? (
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => this.beginEditTabOutput(tab.id)}
              className="w-full bg-yellow-600 hover:bg-yellow-700 text-white rounded-lg px-3 py-2 text-sm shadow"
              disabled={!tab.outputText || !tab.outputText.trim()}
            >
              Edit
            </button>

            <button
              type="button"
              onClick={() => this.copyTabOutput(tab.id)}
              className="w-full bg-sky-700 hover:bg-sky-800 text-white rounded-lg px-3 py-2 text-sm shadow"
              disabled={!tab.outputText || !tab.outputText.trim()}
            >
              Copy
            </button>
          </div>
        ) : (
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() =>
                this.updateTab(tab.id, {
                  isEditingOutput: false,
                  outputOriginalText: tab.outputText || "",
                })
              }
              className="w-full bg-green-700 hover:bg-green-800 text-white rounded-lg px-3 py-2 text-sm shadow"
            >
              Update
            </button>

            <button
              type="button"
              onClick={() => this.cancelEditTabOutput(tab.id)}
              className="w-full bg-gray-100 hover:bg-gray-200 text-gray-900 rounded-lg px-3 py-2 text-sm shadow"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    );
  };



  renderConsultationNoteTab = ({ isDisabled, isEditing, text }) => {
    return (
      <>
        <div className="text-sm font-semibold">Consultation Note</div>

        <div className="xs:ml-16 sm:-ml-[380px] relative">
          <div
            className={`transition-opacity ${
              isDisabled ? "opacity-40 pointer-events-none" : ""
            }`}
          >
            <Transcribe onInputUpdate={this.handleTranscription} />
          </div>

          {isDisabled && (
            <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-600">
              Minimum 10 credits required
            </div>
          )}
        </div>

        <RichTextEditor
          ref={this.richTextRef}
          key={isEditing ? "editing" : "readonly"}
          value={text}
          onChange={(html) => {
            if (!isEditing) return;
            this.setState({ text: html });
          }}
          readOnly={!isEditing}
          className={`quill ${isEditing ? "quill-editing" : "quill-readonly"}`}
        />


        {!isEditing ? (
          <div className="flex gap-2">
            <button
              type="button"
              onClick={this.beginEdit}
              className="w-full bg-yellow-600 hover:bg-yellow-700 text-white rounded-lg px-3 py-2 text-sm shadow"
              disabled={this.state.selectedIndex < 0}
            >
              Edit
            </button>

            <button
              type="button"
              onClick={this.copyNoteToClipboard}
              className="w-full bg-sky-700 hover:bg-sky-800 text-white rounded-lg px-3 py-2 text-sm shadow"
              disabled={!this.state.text || !this.state.text.trim()}
            >
              Copy note
            </button>
          </div>
        ) : (
          <div className="flex gap-2">
            <button
              type="button"
              onClick={this.updateExistingNote}
              className="w-full bg-green-700 hover:bg-green-800 text-white rounded-lg px-3 py-2 text-sm shadow"
            >
              Update
            </button>
            <button
              type="button"
              onClick={this.cancelEdit}
              className="w-full bg-gray-100 hover:bg-gray-200 text-gray-900 rounded-lg px-3 py-2 text-sm shadow"
            >
              Cancel
            </button>
          </div>
        )}

        <div
          className={`m-20 pt-10 transition-opacity ${
            isDisabled ? "opacity-40 pointer-events-none" : ""
          }`}
        >
          <div className="text-center font-semibold text-lg">AI Multi-Processing</div>
          <p className="text-center text-md mb-2">
            Select the appropriate toggle(s) to process the above consultation note into the selected care plan(s).
          </p>

          <button
            type="button"
            onClick={this.processNote}
            className="w-full bg-sky-700 hover:bg-sky-800 text-white rounded-lg px-3 py-2 text-sm shadow"
          >
            Process Note
          </button>

          <div className="flex flex-col gap-2 pt-4 pl-10 border-t">
            {this.renderToggle("GP Chronic Condition Management Plan", "GPCCMP")}
            {this.renderToggle("Mental Health Care Plan", "MHCP")}
            {this.renderToggle("HealthAssessment", "HA")}
          </div>
        </div>
      </>
    );
  };


  render() {
    const list = Array.isArray(this.props.value) ? this.props.value : [];
    const { selectedIndex, text, isEditing, tabs, activeTab, showAddTabModal, newTabTitle } = this.state;
    const currentCredits = this.props.currentCredits;
    const isDisabled = currentCredits < 10;

    const activeTabObj = this.getActiveTabObj();

    return (
      <div className="mt-10">
        <div className="grid grid-cols-3 gap-4 xs:grid-cols-1 sm:grid-cols-1">
          {/* Left column */}
          <div className="col-span-1 border rounded-lg p-3 space-y-2">
            <div className="text-sm font-semibold">Notes</div>

            {list.length === 0 ? (
              <div className="text-sm text-gray-500">No notes yet.</div>
            ) : (
              list.map((item, idx) => {
                const selected = idx === selectedIndex;

                return (
                  <div
                    key={`${item.date || "no-date"}-${idx}`}
                    className={[
                      "border rounded-lg p-3",
                      selected ? "border-sky-700 bg-sky-50" : "border-gray-200 bg-white",
                    ].join(" ")}
                  >
                    <button
                      type="button"
                      className="w-full text-left"
                      onClick={() => this.selectIndex(idx)}
                    >
                      <div className="text-xs text-gray-500">{item.date || "—"}</div>
                      <div className="text-sm text-gray-700 line-clamp-2">
                        {this.htmlToText(item.note || "")}
                      </div>
                    </button>

                    <div className="mt-2 flex gap-2 justify-end">
                      <button
                        type="button"
                        onClick={() => this.deleteItem(idx)}
                        className="text-sm px-2 py-1 rounded bg-red-100 hover:bg-red-200"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* Right column (Tabs + Content) */}
          <div className="col-span-2 border rounded-lg p-3 space-y-3 xs:col-span-1 sm:col-span-1">
            {/* Tabs header */}
            <div className="flex flex-row justify--b">
              <div className="flex">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => this.setState({ activeTab: tab.id })}
                    className={[
                      "px-4 py-2 text-sm font-semibold border-b-2 transition -mb-[1px]",
                      activeTab === tab.id
                        ? "border-sky-700 text-sky-700"
                        : "border-transparent text-gray-500 hover:text-gray-700",
                    ].join(" ")}
                  >
                    {tab.title}
                  </button>
                ))}
              </div>

              <button
                type="button"
                onClick={this.openAddTabModal}
                className="text-sm px-3 py-1 ml-2 rounded bg-slate-200 hover:bg-sky-300 text-slate-600 shadow"
                title="Add a new tab"
              >
                Add Workspace
              </button>
            </div>

            {/* Tab content */}
        

            <div className="min-h-[200px]">
              {this.state.activeTab === "note" ? (
                this.renderConsultationNoteTab({ isDisabled, isEditing, text })
              ) : (
                this.renderCustomTab(activeTabObj)
              )}
            </div>

          </div>

          <ToastContainer />
        </div>

        {/* Add Tab Modal */}
        {showAddTabModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div
              className="absolute inset-0 bg-black/40"
              onClick={this.closeAddTabModal}
            />

            <div className="relative z-10 w-[420px] max-w-[90vw] bg-white rounded-xl shadow-lg p-5">
              <div className="text-sm font-semibold mb-3">Add a new tab</div>

              <input
                value={newTabTitle}
                onChange={this.handleNewTabTitleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                placeholder="Tab title"
                autoFocus
              />

              
              {/* ✅ Suggestions */}
              <div className="flex flex-wrap gap-2 mt-3">
                <button
                  type="button"
                  onClick={() => this.setSuggestedWorkspaceTitle("Referral letter")}
                  className="px-3 py-1 text-xs rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-700"
                >
                  Referral letter
                </button>

                <button
                  type="button"
                  onClick={() => this.setSuggestedWorkspaceTitle("Patient summary")}
                  className="px-3 py-1 text-xs rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-700"
                >
                  Patient summary
                </button>

                <button
                  type="button"
                  onClick={() => this.setSuggestedWorkspaceTitle("Instruction")}
                  className="px-3 py-1 text-xs rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-700"
                >
                  Instruction
                </button>
              </div>

              <div className="flex gap-2 mt-4 justify-end">
                <button
                  type="button"
                  onClick={this.closeAddTabModal}
                  className="px-3 py-2 text-sm rounded-lg bg-gray-100 hover:bg-gray-200"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={this.addNewTab}
                  className="px-3 py-2 text-sm rounded-lg bg-sky-700 hover:bg-sky-800 text-white"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

}

export default Consultation;
